import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { RouteError } from "../../../shared/components/RouteError";
import { RoutePending } from "../../../shared/components/RoutePending";
import { listSearch } from "../../../shared/utils/pagination-search";

const searchSchema = listSearch.extend({
  entityTypeId: z.string().optional(),
  customerId: z.string().optional(),
});

/**
 * @purpose Review the actors that can execute transitions (users, roles, system processes)
 * @primary Entities table
 * @persona danilo-tech
 */
export const Route = createFileRoute("/app/admin/fsm-workflows/entities/")({
  validateSearch: searchSchema,
  errorComponent: ({ error }) => <RouteError error={error} />,
  pendingComponent: RoutePending,
});
